function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["arrowSvgProps", "autoFocus", "children", "closeButtonLabel", "closeButtonProps", "closeOnClickAway", "container", "containerOffset", "content", "elementToFocus", "focusLock", "focusLockProps", "footer", "height", "id", "insidePopout", "labels", "loading", "onClose", "open", "openOnHover", "placement", "popoutDialogBodyProps", "popoutDialogFooterProps", "popoutDialogHeaderProps", "popoutDialogHeadingProps", "popoutDialogInnerProps", "popoutDialogProps", "popoutDialogTitleProps", "preventCutoff", "setOpen", "showArrow", "showCloseButton", "title", "titleAfter", "titleBefore", "transitionDelay", "transitionDuration", "triggerOffset", "triggerWrapperProps", "variant", "width"],
  _excluded2 = ["ref", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import FocusLock, { AutoFocusInside } from 'react-focus-lock';
import { useLayer, Arrow } from 'react-laag';
import { Transition } from 'react-transition-group';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import { Placements } from "../../../../enums/placements.js";
import { PopoutVariants } from "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useClickOutside } from "../../../../hooks/use-click-outside.js";
import "../../../../utilities/color.js";
import { getContainer } from "../../../../utilities/container.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import { useHover } from "../../../../hooks/use-hover.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { transitionFadeIn } from "../../../../styles/transitions/fade-in.js";
import '@brandfolder/utilities';
import { CloseButton } from "../../button/close-button/close-button.js";
import "../../button/color-button/color-button.js";
import "../../tooltip/hover-tooltip/hover-tooltip.js";
import "../../icon/font-icon/font-icon.js";
import "../../button/icon-button/icon-button.js";
import "../../button/standard-button/standard-button.js";
import { CircleLoader } from "../../loader/circle-loader/circle-loader.js";
import "../../loader/shimmer-loader/shimmer-loader.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BasePopout = function BasePopout(props) {
  var _classnames7;
  var arrowSvgProps = props.arrowSvgProps,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    children = props.children,
    closeButtonLabel = props.closeButtonLabel,
    closeButtonProps = props.closeButtonProps,
    _props$closeOnClickAw = props.closeOnClickAway,
    closeOnClickAway = _props$closeOnClickAw === void 0 ? false : _props$closeOnClickAw,
    container = props.container,
    _props$containerOffse = props.containerOffset,
    containerOffset = _props$containerOffse === void 0 ? 10 : _props$containerOffse,
    content = props.content,
    elementToFocus = props.elementToFocus,
    _props$focusLock = props.focusLock,
    focusLock = _props$focusLock === void 0 ? true : _props$focusLock,
    focusLockProps = props.focusLockProps,
    footer = props.footer,
    height = props.height,
    id = props.id,
    insidePopout = props.insidePopout,
    labels = props.labels,
    loading = props.loading,
    onClose = props.onClose,
    open = props.open,
    openOnHover = props.openOnHover,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? Placements.TopCenter : _props$placement,
    popoutDialogBodyProps = props.popoutDialogBodyProps,
    popoutDialogFooterProps = props.popoutDialogFooterProps,
    popoutDialogHeaderProps = props.popoutDialogHeaderProps,
    popoutDialogHeadingProps = props.popoutDialogHeadingProps,
    popoutDialogInnerProps = props.popoutDialogInnerProps,
    popoutDialogProps = props.popoutDialogProps,
    popoutDialogTitleProps = props.popoutDialogTitleProps,
    _props$preventCutoff = props.preventCutoff,
    preventCutoff = _props$preventCutoff === void 0 ? true : _props$preventCutoff,
    setOpen = props.setOpen,
    _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    title = props.title,
    titleAfter = props.titleAfter,
    titleBefore = props.titleBefore,
    _props$transitionDela = props.transitionDelay,
    transitionDelay = _props$transitionDela === void 0 ? 0 : _props$transitionDela,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 200 : _props$transitionDura,
    _props$triggerOffset = props.triggerOffset,
    triggerOffset = _props$triggerOffset === void 0 ? 8 : _props$triggerOffset,
    triggerWrapperProps = props.triggerWrapperProps,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? PopoutVariants.None : _props$variant,
    _props$width = props.width,
    width = _props$width === void 0 ? 300 : _props$width,
    otherProps = _objectWithoutProperties(props, _excluded);
  var ariaLabelledBy = title ? "".concat(id, "-label") : undefined;
  var popoutId = "".concat(id, "-popout");
  var timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredDelayed = _useState2[0],
    setHoveredDelayed = _useState2[1];
  var wrapperRef = useRef(null);
  var _useClickOutside = useClickOutside({
      ref: wrapperRef
    }),
    clickedOutside = _useClickOutside.clickedOutside;
  var nodeRef = useRef(null);
  var _useHover = useHover(),
    hoverProps = _useHover.hoverProps,
    hovered = _useHover.hovered,
    setHovered = _useHover.setHovered;
  var handleOnClose = function handleOnClose() {
    if (onClose) onClose();
  };
  var handleClose = function handleClose() {
    handleOnClose();
    setHoveredDelayed(false);
    setHovered(false);
    setOpen(false);
  };
  var onOutsideClick = function onOutsideClick() {
    if (closeOnClickAway) {
      handleClose();
    }
  };
  var isOpen = open || hoveredDelayed;
  var _useLayer = useLayer({
      auto: preventCutoff,
      container: container || getContainer(popoutId),
      containerOffset: containerOffset,
      isOpen: isOpen,
      placement: placement,
      onOutsideClick: onOutsideClick,
      triggerOffset: triggerOffset
    }),
    arrowProps = _useLayer.arrowProps,
    layerProps = _useLayer.layerProps,
    renderLayer = _useLayer.renderLayer,
    triggerProps = _useLayer.triggerProps;
  var ref = layerProps.ref,
    layerPropsStyle = layerProps.style,
    otherLayerProps = _objectWithoutProperties(layerProps, _excluded2);
  useEffect(function () {
    if (openOnHover) {
      if (hovered) {
        setHoveredDelayed(true);
      } else {
        setTimeout(function () {
          setHoveredDelayed(false);
        }, timeout);
      }
    }
  }, [hovered, openOnHover]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (elementToFocus !== null && elementToFocus !== void 0 && elementToFocus.current) {
      elementToFocus.current.focus();
    }
  }, [elementToFocus]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (insidePopout && clickedOutside && closeOnClickAway) {
      handleClose();
    }
  }, [clickedOutside]); // eslint-disable-line react-hooks/exhaustive-deps
  var showClose = open && showCloseButton;
  var renderHeader = function renderHeader() {
    return /*#__PURE__*/React.createElement("header", _extends({}, popoutDialogHeaderProps, {
      className: classnames(_defineProperty({
        'bf-popout__header': true
      }, "".concat(popoutDialogHeaderProps === null || popoutDialogHeaderProps === void 0 ? void 0 : popoutDialogHeaderProps.className), !!(popoutDialogHeaderProps !== null && popoutDialogHeaderProps !== void 0 && popoutDialogHeaderProps.className)))
    }), titleBefore, title && /*#__PURE__*/React.createElement("div", _extends({}, popoutDialogTitleProps, {
      className: classnames(_defineProperty({
        'bf-popout__title': true
      }, "".concat(popoutDialogTitleProps === null || popoutDialogTitleProps === void 0 ? void 0 : popoutDialogTitleProps.className), !!(popoutDialogTitleProps !== null && popoutDialogTitleProps !== void 0 && popoutDialogTitleProps.className)))
    }), /*#__PURE__*/React.createElement("h6", _extends({}, popoutDialogHeadingProps, {
      className: classnames(_defineProperty({
        'bf-popout__heading': true
      }, "".concat(popoutDialogHeadingProps === null || popoutDialogHeadingProps === void 0 ? void 0 : popoutDialogHeadingProps.className), !!(popoutDialogHeadingProps !== null && popoutDialogHeadingProps !== void 0 && popoutDialogHeadingProps.className))),
      id: ariaLabelledBy
    }), title)), titleAfter, /*#__PURE__*/React.createElement(CloseButton, _extends({}, closeButtonProps, {
      "aria-label": (labels === null || labels === void 0 ? void 0 : labels.closeButtonLabel) || closeButtonLabel || '',
      className: classnames(_defineProperty({
        'bf-popout__close': true,
        'bf-popout__close--hidden': !showClose
      }, "".concat(closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.className), !!(closeButtonProps !== null && closeButtonProps !== void 0 && closeButtonProps.className))),
      onClick: function onClick() {
        return handleClose();
      }
    })));
  };
  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !loading && content, (labels === null || labels === void 0 ? void 0 : labels.loaderLabel) && loading && /*#__PURE__*/React.createElement(CircleLoader, {
      label: labels === null || labels === void 0 ? void 0 : labels.loaderLabel
    }));
  };
  var renderInner = function renderInner() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderHeader(), /*#__PURE__*/React.createElement("div", _extends({}, popoutDialogBodyProps, {
      className: classnames(_defineProperty({
        'bf-popout__body': true
      }, "".concat(popoutDialogBodyProps === null || popoutDialogBodyProps === void 0 ? void 0 : popoutDialogBodyProps.className), !!(popoutDialogBodyProps !== null && popoutDialogBodyProps !== void 0 && popoutDialogBodyProps.className)))
    }), autoFocus ? /*#__PURE__*/React.createElement(AutoFocusInside, {
      className: "bf-popout__autofocus"
    }, renderContent()) : renderContent()), footer && /*#__PURE__*/React.createElement("footer", _extends({}, popoutDialogFooterProps, {
      className: classnames(_defineProperty({
        'bf-popout__footer': true
      }, "".concat(popoutDialogFooterProps === null || popoutDialogFooterProps === void 0 ? void 0 : popoutDialogFooterProps.className), !!(popoutDialogFooterProps !== null && popoutDialogFooterProps !== void 0 && popoutDialogFooterProps.className)))
    }), footer));
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, hoverProps, {
    className: classnames((_classnames7 = {
      'bf-popout': true,
      'bf-popout--hovered': hoveredDelayed,
      'bf-popout--loading': loading,
      'bf-popout--open': isOpen
    }, _defineProperty(_classnames7, "bf-popout__".concat(variant), variant !== PopoutVariants.None), _defineProperty(_classnames7, "".concat(otherProps === null || otherProps === void 0 ? void 0 : otherProps.className), !!(otherProps !== null && otherProps !== void 0 && otherProps.className)), _classnames7)),
    id: popoutId,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement("span", _extends({}, triggerWrapperProps, triggerProps, {
    className: classnames(_defineProperty({
      'bf-popout__trigger': true
    }, "".concat(triggerWrapperProps === null || triggerWrapperProps === void 0 ? void 0 : triggerWrapperProps.className), !!(triggerWrapperProps !== null && triggerWrapperProps !== void 0 && triggerWrapperProps.className)))
  }), children), renderLayer( /*#__PURE__*/React.createElement(Transition, {
    appear: isOpen,
    in: isOpen,
    mountOnEnter: true,
    nodeRef: nodeRef,
    timeout: timeout,
    unmountOnExit: true
  }, function (transitionStatus) {
    var _classnames9, _classnames10;
    return /*#__PURE__*/React.createElement("div", _extends({}, popoutDialogProps, otherLayerProps, {
      "aria-labelledby": ariaLabelledBy,
      className: classnames((_classnames9 = {
        'bf-popout__dialog': true
      }, _defineProperty(_classnames9, "bf-popout__dialog--has-arrow", showArrow), _defineProperty(_classnames9, "".concat(popoutDialogProps === null || popoutDialogProps === void 0 ? void 0 : popoutDialogProps.className), !!(popoutDialogProps !== null && popoutDialogProps !== void 0 && popoutDialogProps.className)), _classnames9)),
      id: id,
      ref: mergeRefs([nodeRef, ref]),
      role: "dialog",
      style: _objectSpread(_objectSpread(_objectSpread({}, popoutDialogProps === null || popoutDialogProps === void 0 ? void 0 : popoutDialogProps.style), layerPropsStyle), {}, {
        height: height,
        width: width
      }, transitionFadeIn({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      }))
    }), /*#__PURE__*/React.createElement("div", _extends({}, popoutDialogInnerProps, {
      className: classnames((_classnames10 = {
        'bf-popout__dialog-inner': true
      }, _defineProperty(_classnames10, "bf-popout__dialog-inner--".concat(placement), placement), _defineProperty(_classnames10, "bf-popout__dialog-inner--has-close-button", showClose), _defineProperty(_classnames10, "bf-popout__dialog-inner--has-footer", !!footer), _defineProperty(_classnames10, "bf-popout__dialog-inner--has-title", !!title), _defineProperty(_classnames10, "".concat(popoutDialogInnerProps === null || popoutDialogInnerProps === void 0 ? void 0 : popoutDialogInnerProps.className), !!(popoutDialogInnerProps !== null && popoutDialogInnerProps !== void 0 && popoutDialogInnerProps.className)), _classnames10)),
      style: _objectSpread(_objectSpread({}, popoutDialogInnerProps === null || popoutDialogInnerProps === void 0 ? void 0 : popoutDialogInnerProps.style), {}, {
        height: height,
        width: width
      })
    }), focusLock ? /*#__PURE__*/React.createElement(FocusLock, _extends({}, focusLockProps, {
      className: classnames(_defineProperty({
        'bf-popout__focus-lock': true
      }, "".concat(focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.className), !!(focusLockProps !== null && focusLockProps !== void 0 && focusLockProps.className))),
      crossFrame: (focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.crossFrame) || false
    }), renderInner()) : renderInner()), showArrow && /*#__PURE__*/React.createElement(Arrow, _extends({
      onPointerEnterCapture: undefined,
      onPointerLeaveCapture: undefined
    }, arrowSvgProps, arrowProps, {
      className: classnames(_defineProperty({
        'bf-popout__arrow': true
      }, "bf-popout__arrow--".concat(placement), placement))
    })));
  })));
};
export { BasePopout };